<template>
    
    <div class="card">
        <div class="card-body">
            <h5 class="card-title">{{ title }}</h5>
            <revenue-chart :height="200" />
        </div>
    </div>
    
</template>

<script>

    import RevenueChart from './Charts/RevenueChart'

    export default {
        name: 'ChartBox',
        props: {
            title: String,
            data: Object,
        },
        components: {
            RevenueChart
        }
    }
</script>

<style scoped>

</style>
